import { render, staticRenderFns } from "./CoverPageModal.vue?vue&type=template&id=5ecaf992&scoped=true&"
import script from "./CoverPageModal.vue?vue&type=script&lang=js&"
export * from "./CoverPageModal.vue?vue&type=script&lang=js&"
import style0 from "./CoverPageModal.vue?vue&type=style&index=0&id=5ecaf992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecaf992",
  null
  
)

export default component.exports